import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SafetyStandards from './SafetyStandards';
import PrivacyPolicy from './PrivacyPolicy';
import Contact from './Contact';
import Download from './Download';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter([
  { path: '/', element: <App/> },
  { path: '/safety-standards', element: <SafetyStandards /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/contact', element: <Contact /> },
  { path: '/download', element: <Download /> }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
